import { FC, Fragment } from "react";
import { Container, Divider, List, ListItem, ListItemText, Typography } from "@mui/material";
import UserInformation from "../../../../../types/UserInformation";

interface MyProfilProps {
  user: UserInformation
}

const MyProfil: FC<MyProfilProps> = ({ user }) => {
  const infos = [
    {
      title: 'Nom :',
      value: user?.name
    },
    {
      title: 'Prenom :',
      value: user?.prenom
    },
    {
      title: 'Email :',
      value: user?.email
    },
    {
      title: 'Département :',
      value: user?.Departement
    },
    {
      title: 'Profil :',
      value: user?.profils?.libelle
    }
  ];

  const usersPays = () => {
    const tabPays: string[] = [];

    if (user) {
      for (let pays of user?.pays) {
        tabPays.push(pays?.libelle);
      }
    }

    return tabPays.join(' / ');
  }

  return (
    <Fragment>
      <Typography variant="h6" color="#FC8404">
        Mon information
      </Typography>
      <Container maxWidth="md">
        <List dense>
          {infos.map(info => (
            <>
              <ListItem key={info.title} sx={{ py: 0 }}>
                <ListItemText primary={info.title} secondary={info.value} />
              </ListItem>
              <Divider />
            </>
          ))}
          <ListItem>
            <ListItemText primary="Pays" secondary={usersPays()} />
          </ListItem>
          <Divider />
        </List>
      </Container>
    </Fragment>
  );
};

export default MyProfil;